import { render, staticRenderFns } from "./EditPhoneNumberModal.vue?vue&type=template&id=eac3ab90&"
import script from "./EditPhoneNumberModal.vue?vue&type=script&lang=ts&"
export * from "./EditPhoneNumberModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eac3ab90')) {
      api.createRecord('eac3ab90', component.options)
    } else {
      api.reload('eac3ab90', component.options)
    }
    module.hot.accept("./EditPhoneNumberModal.vue?vue&type=template&id=eac3ab90&", function () {
      api.rerender('eac3ab90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/phone-number/EditPhoneNumberModal.vue"
export default component.exports